"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="AppointmentBody.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxAppointmentBody object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxAppointmentBody = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxExtractedKeyPhrase_1 = require("./HxExtractedKeyPhrase");
var HxDailyPattern_1 = require("./HxDailyPattern");
var HxEndDatePatternRange_1 = require("./HxEndDatePatternRange");
var HxMonthlyAbsolutePattern_1 = require("./HxMonthlyAbsolutePattern");
var HxMonthlyRelativePattern_1 = require("./HxMonthlyRelativePattern");
var HxNoEndPatternRange_1 = require("./HxNoEndPatternRange");
var HxNumberedPatternRange_1 = require("./HxNumberedPatternRange");
var HxWeeklyPattern_1 = require("./HxWeeklyPattern");
var HxYearlyAbsolutePattern_1 = require("./HxYearlyAbsolutePattern");
var HxYearlyRelativePattern_1 = require("./HxYearlyRelativePattern");
var HxAppointmentBody = /** @class */ (function (_super) {
    __extends(HxAppointmentBody, _super);
    function HxAppointmentBody(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxAppointmentBody, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxAppointmentBody.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '23A':
                        this.attachmentsId = new HxObjectID_1.default(v);
                        break;
                    case '239':
                        this.attendeesId = new HxObjectID_1.default(v);
                        break;
                    case '23C':
                        this.bodyBytes = Buffer.from(v, 'base64');
                        break;
                    case '240':
                        this.bodyType = v;
                        break;
                    case '237':
                        this.cancellationTime = new Date(v);
                        break;
                    case '1035':
                        this.conferenceMeetingInfo = v;
                        break;
                    case '9CF':
                        this.enhancedLocationCollectionId = new HxObjectID_1.default(v);
                        break;
                    case '3F3':
                        this.enterpriseID = v;
                        break;
                    case '23B':
                        var exceptionalPropertiesValues = v;
                        this.exceptionalProperties = new Array(exceptionalPropertiesValues.length);
                        for (var i = 0; i < exceptionalPropertiesValues.length; i++) {
                            this.exceptionalProperties[i] = exceptionalPropertiesValues[i];
                        }
                        break;
                    case '1214':
                        this.extractedContacts = v;
                        break;
                    case '1215':
                        this.extractedEmailAddresses = v;
                        break;
                    case '13E4':
                        var extractedKeyPhrasesValues = v;
                        this.extractedKeyPhrases = new Array(extractedKeyPhrasesValues.length);
                        for (var i = 0; i < extractedKeyPhrasesValues.length; i++) {
                            this.extractedKeyPhrases[i] = HxExtractedKeyPhrase_1.deserializeHxExtractedKeyPhrase(extractedKeyPhrasesValues[i]);
                        }
                        break;
                    case '1216':
                        this.extractedMeetings = v;
                        break;
                    case '13E5':
                        this.extractedOofData = v;
                        break;
                    case '1217':
                        this.extractedPhoneNumbers = v;
                        break;
                    case '1218':
                        this.extractedPostalAddresses = v;
                        break;
                    case '1219':
                        this.extractedTasks = v;
                        break;
                    case '121A':
                        this.extractedUrls = v;
                        break;
                    case '235':
                        this.importance = v;
                        break;
                    case '23F':
                        this.intendedFreeBusyState = v;
                        break;
                    case '41C':
                        this.notificationHistory = v;
                        break;
                    case 'EEA':
                        this.onlineMeetingConferenceId = v;
                        break;
                    case '23D':
                        this.onlineMeetingConfLink = v;
                        break;
                    case '23E':
                        this.onlineMeetingExternalLink = v;
                        break;
                    case 'EEB':
                        this.onlineMeetingJoinUrl = v;
                        break;
                    case 'E86':
                        this.onlineMeetingProvider = v;
                        break;
                    case 'EEC':
                        this.onlineMeetingQuickDial = v;
                        break;
                    case 'EED':
                        var onlineMeetingTollFreeNumbersValues = v;
                        this.onlineMeetingTollFreeNumbers = new Array(onlineMeetingTollFreeNumbersValues.length);
                        for (var i = 0; i < onlineMeetingTollFreeNumbersValues.length; i++) {
                            this.onlineMeetingTollFreeNumbers[i] = onlineMeetingTollFreeNumbersValues[i];
                        }
                        break;
                    case 'EEE':
                        this.onlineMeetingTollNumber = v;
                        break;
                    case 'BF0':
                        this.repeatSeriesData_DailyPattern = HxDailyPattern_1.deserializeHxDailyPattern(v);
                        break;
                    case 'BF1':
                        this.repeatSeriesData_EndDatePatternRange = HxEndDatePatternRange_1.deserializeHxEndDatePatternRange(v);
                        break;
                    case 'BF2':
                        this.repeatSeriesData_MonthlyAbsolutePattern = HxMonthlyAbsolutePattern_1.deserializeHxMonthlyAbsolutePattern(v);
                        break;
                    case 'BF3':
                        this.repeatSeriesData_MonthlyRelativePattern = HxMonthlyRelativePattern_1.deserializeHxMonthlyRelativePattern(v);
                        break;
                    case 'BF4':
                        this.repeatSeriesData_NoEndPatternRange = HxNoEndPatternRange_1.deserializeHxNoEndPatternRange(v);
                        break;
                    case 'BF5':
                        this.repeatSeriesData_NumberedPatternRange = HxNumberedPatternRange_1.deserializeHxNumberedPatternRange(v);
                        break;
                    case 'BF6':
                        this.repeatSeriesData_Pattern = v;
                        break;
                    case 'BF7':
                        this.repeatSeriesData_PatternRange = v;
                        break;
                    case 'BF8':
                        this.repeatSeriesData_WeeklyPattern = HxWeeklyPattern_1.deserializeHxWeeklyPattern(v);
                        break;
                    case 'BF9':
                        this.repeatSeriesData_YearlyAbsolutePattern = HxYearlyAbsolutePattern_1.deserializeHxYearlyAbsolutePattern(v);
                        break;
                    case 'BFA':
                        this.repeatSeriesData_YearlyRelativePattern = HxYearlyRelativePattern_1.deserializeHxYearlyRelativePattern(v);
                        break;
                    case '236':
                        this.sendTime = new Date(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxAppointmentBody.prototype.getAttachments = function (sessionId) {
        return this.activeSet.getCollection(this.attachmentsId, sessionId);
    };
    HxAppointmentBody.prototype.getAttendees = function (sessionId) {
        return this.activeSet.getCollection(this.attendeesId, sessionId);
    };
    HxAppointmentBody.prototype.getEnhancedLocationCollection = function (sessionId) {
        return this.activeSet.getCollection(this.enhancedLocationCollectionId, sessionId);
    };
    return HxAppointmentBody;
}(HxObject_1.default));
exports.HxAppointmentBody = HxAppointmentBody;
exports.default = HxAppointmentBody;
